import APIsList from '@/components/Datasets/APIs';

const APIsListPage = () => {
  return <APIsList />;
};

export default APIsListPage;
